module.exports = "https://trybtryb-legacy.web.app/img/info.00333f13.svg";